export const SET_AGENTS = 'SET_AGENTS'
export const SET_AGENTS_STATUSES = 'SET_AGENTS_STATUSES'
export const SET_AGENTS_SEARCH = 'SET_AGENTS_SEARCH'
export const RESET_AGENTS = 'RESET_AGENTS'
export const RESET_AGENTS_SEARCH = 'RESET_AGENTS_SEARCH'
export const UPDATE_AGENT_STATUS = 'UPDATE_AGENT_STATUS'
export const UPDATE_AGENT_SIGNED_IN = 'UPDATE_AGENT_SIGNED_IN'
